import axios from './axios';

// POST create employee
export async function createEmployee(data) {
  try {
    const response = await axios.post('/owner/employees/create/', data);
    return response.data;
  } catch (error) {
    throw error;
  }
}
